<template src="./index.html">
</template>
<script>
	import vHead from '../../layout/Header';
	import vSidebar from '../../layout/Sidebar';
	import vTags from '../../layout/Tags';
	import bus from '../../util/bus';
	import Watermark from '../../../../waterMark.js'
	import confing from '../../../../configHttp.js'
	export default {
		data() {
			return {
				tagsList: [],
				collapse: false,
				confing:confing,
			};
		},
		components: {
			vHead,
			vSidebar,
			vTags
		},
		mounted() {
			if(this.confing.company=='mb'){
			if(this.$route.path!='/home'){
				this.changebackY()
			}
			this.$router.beforeEach((to, from, next) => {
				if (to.path == '/home' ) {
				Watermark.set('', this.$refs.container);
				}else{
					this.changebackY()
				} 
				next();
			});	
			}
			
		  },
		created() {
			bus.$on('collapse-content', msg => {
				this.collapse = msg;
			});
			// 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
			bus.$on('tags', msg => {
				let arr = [];
				for (let i = 0, len = msg.length; i < len; i++) {
					msg[i].name && arr.push(msg[i].name);
				}
				this.tagsList = arr;
			});
		},
		
		methods: {
			changebackY(){
				if(this.$notemptyandnull(localStorage.getItem('userInfo'))){
					let content=this.$getNowDate()+'-'+JSON.parse(localStorage.getItem('userInfo')).remark
					Watermark.set(content, this.$refs.container);
				}
			},
			yinc(){
				bus.$emit('log', '')
			},
		}
	};
</script>
